import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { JobProvider } from './contexts/JobContext';
import { useAuth } from './contexts/AuthContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import WhatsAppVerification from './pages/WhatsAppVerification';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Jobs from './pages/Jobs';
import UploadCV from './pages/UploadCV';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  // Ensure the title is set correctly
  useEffect(() => {
    document.title = 'suitup - לעבודת החלומות שלך';
  }, []);

  return (
    <Router>
      <AuthProvider>
        <JobProvider>
          <div className="min-h-screen bg-gradient-to-b from-white/50 to-yellow-500 rtl" dir="rtl">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-whatsapp" element={<WhatsAppVerification />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Protected routes */}
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/jobs" 
                element={
                  <ProtectedRoute>
                    <Jobs />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/upload-cv" 
                element={
                  <ProtectedRoute>
                    <UploadCV />
                  </ProtectedRoute>
                } 
              />
              
              {/* Default route */}
              <Route path="/" element={<Navigate to="/jobs" />} />
              <Route path="*" element={<Navigate to="/jobs" />} />
            </Routes>
          </div>
        </JobProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
